<template>
    <b-modal size="lg" @hide="onHide" ref="mdlGestioneAppuntamento" title="Appuntamento Scheduler"
        @shown="onShownGestioneAppuntamento" centered>
        <template v-if="tabSpostaAppuntamento == 1">
            <b-row>
                <b-col cols="6">
                    <b-row>
                        <b-col cols="12">
                            <label class="w-100">Appuntamenti di {{
                                appuntamentoSelRow.identificativoAppuntamento
                            }}</label>
                            <label class="w-100">Prestazione e Codice</label>
                            <span> {{ appuntamentoSelRow.descrizionePrestazione }} ({{
                                appuntamentoSelRow.codicePrestazione
                            }})</span>
                        </b-col>

                        <b-col cols="12" v-if="appuntamentoSelezionatoDaSpostare != null">
                            <label class="font-weight-bold">Sposta Appuntamento</label>

                            <b-row>
                                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                    <b-form-group label="Agenda" class="sa-ft-label">
                                        <b-form-select v-model="spostaAppuntamentoJsonData.idAgenda"
                                            :options="agendaOptions" value-field="id" text-field="titolo"
                                            :disabled="isAgendaEnable">
                                            <template #first>
                                                <b-form-select-option :value="null"
                                                    disabled>Seleziona</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>

                                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                    <b-form-group label="Data Riferimento" class="sa-ft-label">
                                        <date-picker v-model="dataRiferimentoDate" format="DD-MM-YYYY"
                                            value-type="timestamp" placeholder="Seleziona Data" type="date"
                                            class="w-100"> </date-picker>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                </b-col>
                <b-col cols="6">
                    <b-row>
                        <b-col cols="12" class="mb-3">
                            <div class="p-2 border rounded" style="background-color: #f8f9fa;">
                                <label class="w-100 font-weight-bold">Dettaglio Vecchio Appuntamento</label>
                                <b-row>
                                    <b-col md="4">
                                        <small class="text-muted d-block">Data Riferimento</small>
                                        <strong class="w-100 d-block">{{
                                            formattaData(appuntamentoSelezionatoDaSpostare.dataRiferimento)
                                        }}</strong>
                                        <small>{{
                                            getGiornoSettimana(appuntamentoSelezionatoDaSpostare.dataRiferimento).toUpperCase()
                                        }}</small>
                                    </b-col>
                                    <b-col md="4">
                                        <small class="text-muted d-block">Orario</small>
                                        <strong>
                                            {{ getOrario(appuntamentoSelezionatoDaSpostare.dataOraInizio) }}
                                            -
                                            {{ getOrario(appuntamentoSelezionatoDaSpostare.dataOraFine) }}
                                        </strong>
                                    </b-col>
                                    <b-col md="4">
                                        <small class="text-muted d-block">Info Appuntamento</small>
                                        <strong>Accesso n° {{ appuntamentoSelezionatoDaSpostare.numeroOrdine
                                        }}</strong>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="p-2 border rounded" style="background-color: #f8f9fa;"
                                v-if="nuovaDisponibilitaSelezionata">
                                <label class="w-100 font-weight-bold">Dettaglio Nuovo Appuntamento</label>
                                <b-row>
                                    <b-col md="4">
                                        <small class="text-muted d-block">Data Riferimento</small>
                                        <strong class="w-100 d-block">{{
                                            formattaData(spostaAppuntamentoJsonData.dataRiferimento)
                                        }}</strong>
                                        <small>{{
                                            getGiornoSettimana(spostaAppuntamentoJsonData.dataRiferimento).toUpperCase()
                                        }}</small>
                                    </b-col>
                                    <b-col md="4">
                                        <small class="text-muted d-block">Orario</small>
                                        <strong>
                                            {{ getOrario(spostaAppuntamentoJsonData.dataOraInizio) }}
                                            -
                                            {{ getOrario(spostaAppuntamentoJsonData.dataOraFine) }}
                                        </strong>
                                    </b-col>
                                    <b-col md="4">
                                        <small class="text-muted d-block">Info Appuntamento</small>
                                        <strong>Accesso n° {{ spostaAppuntamentoJsonData.numeroOrdine
                                        }}</strong>
                                    </b-col>
                                </b-row>
                            </div>
                            <div v-else class="p-2 border rounded " style="background-color: #f8f9fa;height:85px ">
                                Seleziona Orario per schedulare nuovo appuntamento
                            </div>
                        </b-col>
                    </b-row>



                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col v-if="isAgendaEnable" cols="8">
                    <label for="">Seleziona un Appuntamento </label>
                    <div class="b-table-sticky-header" style="height: 300px;">
                        <b-table selectable sticky-header ref="table" stacked="xl" striped hover
                            :items="prestazioneSelezionata.appuntament" select-mode="single" :fields="fieldAppuntamenti"
                            sort-by="numeroOrdine" @row-selected="setRowSelected" sort-icon-left head-variant="light"
                            class="sa-b-table">
                            <template #cell(index)="row">
                                {{ row.index + 1 }}
                            </template>
                            <template #cell(numeroOrdine)="row">
                                <strong style="width: 100%; display: inline-block;">{{
                                    row.item.numeroOrdine }}</strong>

                            </template>
                            <template #cell(riferimento)="row">
                                <strong style="font-size: small; display: inline-block;">
                                    <strong class="w-100 d-block">{{
                                        formattaData(row.item.dataRiferimento)
                                    }}</strong>
                                    <small>{{
                                        getGiornoSettimana(row.item.dataRiferimento).toUpperCase()
                                    }}</small>
                                    <br>
                                    {{ getOrario(row.item.dataOraInizio) }} - {{
                                        getOrario(row.item.dataOraFine)
                                    }}
                                </strong>
                            </template>
                            <template #cell(statoAttuale)="row">
                                <strong style="font-size: small; display: inline-block;">
                                    {{ row.item.statoAttuale }}
                                    <br>

                                </strong>
                            </template>
                        </b-table>
                    </div>
                </b-col>
                <b-col :cols="isAgendaEnable ? 4 : 12">
                    <label>Seleziona Nuova Disponibilità</label>
                    <div class="b-table-sticky-header" style="height: 300px;">
                        <b-table selectable ref="tblDisponibilita" select-mode="single" striped hover
                            :items="disponibilitaAgendaItems[0].disponibilita" :fields="fieldDisponibilita"
                            @row-selected="onDisponibilitaSelected" head-variant="light">
                            <template #cell(seleziona)="row">
                                <b-icon :icon="row.rowSelected ? 'check-circle-fill' : 'circle'"
                                    :variant="row.rowSelected ? 'primary' : 'secondary'"></b-icon>
                            </template>
                            <template #cell(dataRiferimento)="row">
                                <strong style="width: 100%;font-size: small; display: inline-block;">
                                    {{ formattaData(row.item.dataRiferimento) }}
                                    <br>
                                    <small style="width: 100%; display: inline-block;"> {{
                                        getGiornoSettimana(row.item.dataRiferimento).toUpperCase()
                                    }}</small>
                                    <br>
                                    <strong style="font-size: small; display: inline-block;">
                                        {{ row.item.dalleOre }} - {{
                                            row.item.alleOre
                                        }}
                                    </strong>
                                </strong>
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-row>

        </template>
        <template v-if="tabSpostaAppuntamento == 2">
            <label class="sa-ft-label">Nuovo Schema Appuntamenti</label>
            <div class="b-table-sticky-header" style="height: 500px;">
                <b-table sticky-header ref="table" stacked="xl" striped hover :items="appuntamentiTmpConferma"
                    :fields="fieldAppuntamenti" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ row.index + 1 }}
                    </template>
                    <template #cell(numeroOrdine)="row">
                        <strong style="width: 100%; display: inline-block;">{{
                            row.item.numeroOrdine }}</strong>

                    </template>
                    <template #cell(riferimento)="row">
                        <strong style="font-size: small; display: inline-block;">
                            <strong class="w-100 d-block">{{
                                formattaData(row.item.dataRiferimento)
                            }}</strong>
                            <small>{{
                                getGiornoSettimana(row.item.dataRiferimento).toUpperCase()
                            }}</small>
                            <br>
                            {{ getOrario(row.item.dataOraInizio) }} - {{
                                getOrario(row.item.dataOraFine)
                            }}
                        </strong>
                    </template>
                    <template #cell(statoAttuale)="row">
                        <strong style="font-size: small; display: inline-block;">
                            {{ row.item.statoAttuale }}
                            <br>

                        </strong>
                    </template>
                </b-table>
            </div>

        </template>

        <template #modal-footer>
            <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">

                <b-button variant="danger" v-if="tabSpostaAppuntamento == 1"
                    @click="onAnnullaSpostaAppuntamento">Annulla</b-button>

                <b-button variant="secondary" v-if="isAgendaEnable"
                    @click="tabSpostaAppuntamento = 1">Indietro</b-button>

                <b-button variant="success" v-if="tabSpostaAppuntamento == 1 && isAgendaEnable"
                    @click="tabSpostaAppuntamento = 2">
                    Conferma
                </b-button>

                <b-button variant="success" v-if="tabSpostaAppuntamento == 1 && !isAgendaEnable"
                    @click="onConfermaAppuntamentoSingle">
                    Conferma Appuntamento
                </b-button>

                <b-button variant="success" v-if="tabSpostaAppuntamento == 2 && isAgendaEnable"
                    @click="onClickSpostaAppuntamento">
                    Sposta Appuntamento
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast.js";
import axios from "axios";
export default {
    name: "GestioneAppuntamentoModalComponent",
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { DatePicker },
    data() {
        return {
            presidio: {},
            pathResourceAgendaDisponibilita: "/agendadisponibilita",
            dataRiferimentoDate: null,
            dataRiferimento: null,
            appuntamentiTmpConferma: [],

            tabSpostaAppuntamento: 1,
            disponibilitaAgendaItems: [{ disponibilita: [] }],
            appuntamentoSelezionatoDaSpostare: {},
            spostaAppuntamentoJsonData: {
                idAgenda: null,
            },
            appuntamentoSelRow: {
                statoAttuale: ""
            },
            indexRicettaSel: null,
            prestazioneSelezionata: {
                appuntament: []
            },
            isAgendaEnable: true,
            agendaOptions: [],
            nuovaDisponibilitaSelezionata: null,
            fieldDisponibilita: [
                { key: 'seleziona', label: '', thStyle: 'width: 50px' },
                { key: 'dataRiferimento', label: 'Slot' },
            ],
            fieldAppuntamenti: [
                {
                    label: "Ordine Appuntamento",
                    key: "numeroOrdine",
                    thStyle: "width: 8rem",
                },
                {
                    label: "Appuntamento",
                    key: "riferimento",
                    thStyle: "width: 15rem",
                },
                {
                    label: "Stato Appuntamento",
                    key: "statoAttuale",
                },
            ],
        };
    },
    watch: {
        dataRiferimentoDate: function (params) {
            this.dataRiferimento = moment(params).format("YYYY-MM-DD");
        },
        dataRiferimento: function (params) {
            if (params) {
                this.loadAgendaDisponibilita();
            }
        },
    },
    mounted() {
        let tmpPresidio = window.localStorage.getItem("presidio");
        if (tmpPresidio && tmpPresidio != "null") {
            this.presidio = JSON.parse(tmpPresidio);
            this.loadAgende();
        }
    },
    methods: {
        showSingleAppuntamento(row, agende, appuntametno, indexRicetta) {
            this.appuntamentoSelRow = row;
            this.indexRicettaSel = indexRicetta;
            if (agende != null) {
                this.agendaOptions = agende;
            }
            this.appuntamentoSelezionatoDaSpostare = appuntametno;
            this.spostaAppuntamentoJsonData.idAgenda = appuntametno.idAgenda
            this.isAgendaEnable = false;
            this.$refs.mdlGestioneAppuntamento.show();
        },
        show(row) {
            this.appuntamentoSelRow = row;

            this.$refs.mdlGestioneAppuntamento.show();
        },
        hide() {
            console.log("hide");

            this.isAgendaEnable = true;
            this.$refs.mdlGestioneAppuntamento.hide();
            this.disponibilitaAgendaItems = [{ disponibilita: [] }];
            if (this.$refs.table) this.$refs.table.clearSelected();
            if (this.$refs.tblDisponibilita) this.$refs.tblDisponibilita.clearSelected();
        },
        onHide() {
            console.log("onHide");
            this.appuntamentoSelezionatoDaSpostare = {};
            this.nuovaDisponibilitaSelezionata = null;
            this.dataRiferimentoDate = null;
            this.disponibilitaAgendaItems = [{ disponibilita: [] }];
            if (this.$refs.table) this.$refs.table.clearSelected();
            if (this.$refs.tblDisponibilita) this.$refs.tblDisponibilita.clearSelected();
        },
        onAnnullaSpostaAppuntamento() {
            this.hide();
        },
        onShownGestioneAppuntamento() {
            this.openShowModalLoading()
            let appuntamento = this.appuntamentoSelRow;

            let idPrestazione = appuntamento.idPrestazione;
            if (idPrestazione) {
                let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioni/" + idPrestazione;
                axios
                    .get(link)
                    .then((response) => {
                        this.prestazioneSelezionata = response.data.data;
                        this.loadAgendaDisponibilita();
                        this.closeShowModalLoading();
                    })
                    .catch((e) => {
                        console.log(e);
                        this.closeShowModalLoading();
                    });
            }
            this.closeShowModalLoading();
        },
        loadAgende() {
            let link = process.env.VUE_APP_PATH_API + "/agende";
            axios
                .get(link, { params: { idPresidio: this.presidio.idPresidio } })
                .then((response) => {
                    this.agendaOptions = response.data.data;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getOrario(data) {
            return moment(data).format("HH:mm");
        },
        formattaData(dataString) {
            if (!dataString) return '--';
            const parti = dataString.split('-');
            return `${parti[2]}/${parti[1]}/${parti[0]} `;
        },
        getGiornoSettimana(dataString) {
            if (!dataString) return '--';
            const giornoSettimana = moment(dataString).locale('it').format('dddd');
            return giornoSettimana;
        },
        setRowSelected(item) {
            if (item && item.length > 0) {
                let app = item[0];
                if (app.statoAttuale == "ESEGUITO" || app.statoAttuale == "NON ESEGUITO") {
                    this.appuntamentoSelezionatoDaSpostare = {};
                    toast.warning("Appuntamento già marcato come " + app.statoAttuale + " , non è possibile spostare!");
                    this.$refs.table.clearSelected();
                    return;
                }
                this.appuntamentoSelezionatoDaSpostare = app;
                this.spostaAppuntamentoJsonData = JSON.parse(JSON.stringify(app));
                this.dataRiferimentoDate = new Date().getTime();
            } else {
                this.appuntamentoSelezionatoDaSpostare = {};
            }
        },
        convertiInTimestamp(data, ora) {
            const dateFinal = `${data}T${ora}:00`;
            return new Date(dateFinal).getTime();
        },
        onDisponibilitaSelected(items) {
            if (items && items.length > 0) {
                this.nuovaDisponibilitaSelezionata = items[0];
                this.spostaAppuntamentoJsonData.dataRiferimento = this.nuovaDisponibilitaSelezionata.dataRiferimento
                this.spostaAppuntamentoJsonData.alleOre = this.nuovaDisponibilitaSelezionata.alleOre
                this.spostaAppuntamentoJsonData.dalleOre = this.nuovaDisponibilitaSelezionata.dalleOre
                this.spostaAppuntamentoJsonData.dataOraFine = this.convertiInTimestamp(this.nuovaDisponibilitaSelezionata.dataRiferimento, this.nuovaDisponibilitaSelezionata.alleOre)
                this.spostaAppuntamentoJsonData.dataOraInizio = this.convertiInTimestamp(this.nuovaDisponibilitaSelezionata.dataRiferimento, this.nuovaDisponibilitaSelezionata.dalleOre)
                this.spostaAppuntamentoJsonData.costo = this.appuntamentoSelRow.costo;
                this.spostaAppuntamentoJsonData.codiceBar1 = this.appuntamentoSelRow.codiceBar1;
                this.spostaAppuntamentoJsonData.codiceBar2 = this.appuntamentoSelRow.codiceBar2;
                this.spostaAppuntamentoJsonData.quantitaErogabile = this.appuntamentoSelRow.quantitaErogabile

                let appuntamentiTmp = JSON.parse(JSON.stringify(this.prestazioneSelezionata.appuntament));

                const index = appuntamentiTmp.findIndex(app => app.id === this.appuntamentoSelezionatoDaSpostare.id);

                if (index !== -1) {
                    appuntamentiTmp[index] = JSON.parse(JSON.stringify(this.spostaAppuntamentoJsonData));
                }
                appuntamentiTmp.sort((a, b) => a.dataOraInizio - b.dataOraInizio);
                appuntamentiTmp = appuntamentiTmp.map((app, idx) => {
                    const nuovoOrdine = idx + 1;
                    if (app.id == this.appuntamentoSelezionatoDaSpostare.id) {
                        this.spostaAppuntamentoJsonData.numeroOrdine = nuovoOrdine;
                    }
                    app.numeroOrdine = nuovoOrdine;
                    return app;
                });
                this.appuntamentiTmpConferma = appuntamentiTmp;
            } else {
                this.nuovaDisponibilitaSelezionata = null;
            }
        },
        loadAgendaDisponibilita() {
            if (JSON.stringify(this.appuntamentoSelezionatoDaSpostare) != "{}") {
                let itemFIlter = {
                    language: "it",
                    idAgenda: this.appuntamentoSelezionatoDaSpostare.idAgenda,
                    periodo: "G",
                    riferimento: this.dataRiferimento,
                    codicePrestazione: this.appuntamentoSelezionatoDaSpostare.codicePrestazione,
                };
                this.disponibilitaAgendaItems = [{ disponibilita: [] }];
                this.openShowModalLoading();
                this.loadDataResources(this.pathResourceAgendaDisponibilita, itemFIlter, this.loadAgendaDisponibilitaSuccess, this.loadAgendaDisponibilitaError);
            }
        },
        loadAgendaDisponibilitaSuccess(response) {
            this.disponibilitaAgendaItems = response.data.data;
            this.closeShowModalLoading();
        },
        loadAgendaDisponibilitaError(error) {
            console.log(error);
            this.closeShowModalLoading();
        },
        onClickSpostaAppuntamento() {
            this.openShowModalLoading()
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/sposta/" + this.spostaAppuntamentoJsonData.id;
            axios.put(link, this.spostaAppuntamentoJsonData)
                .then((response) => {
                    this.closeShowModalLoading()
                    toast.success(response.data.messaggio);
                    setTimeout(() => {
                        this.$emit("appuntamento-spostato");
                    }, 1000);
                })
                .catch((e) => {
                    this.closeShowModalLoading();
                    toast.error(e?.response?.data?.messaggio)
                });
        },
        onConfermaAppuntamentoSingle() {
            this.$emit("conferma-single-appuntamento", this.spostaAppuntamentoJsonData, this.appuntamentoSelRow.index, this.indexRicettaSel)
            this.hide();
        }
    },
};
</script>
